import httpClient from "../api/httpClient";

export default {
  otp_auth_success(state, { token, userdata }) {
    console.log(userdata);
    state.authStatus = "otp_auth_success";
    state.token = token;
    state.user = userdata;
    console.log(state);
  },
  clear_state(state) {
    state = null;
  },
  auth_success(state, { token, userdata, lastUnsuccessfulLogin,approvalDialog,afterLoginPageList }) {
    state.authStatus = "success";
    state.token = token;
    state.user = userdata;
    state.approvalDialog = approvalDialog;
    state.lastUnsuccessfulLogin = lastUnsuccessfulLogin;
    state.afterLoginPageList = afterLoginPageList;
    console.log("BURAYA GİRİYOR MUSUN ? S");
    console.log(state);
  },
  auth_error(state) {
    state.authStatus = "error";
  },
  setUserInformationToHeader({state},data) {
    console.log("----setUserInformationToHeader-----");
    console.log(data);
      httpClient.defaults.headers.common["X-VKN"] = data.selectedCompany;
  },

  createCorrelationHeader({state},data){
    httpClient.defaults.headers.common["X-CORR"] = data;
  },

  logout(state) {
    state.authStatus = "";
    state.token = "";
    state.user = null;

  },
};
